import PageAnimation from './page-animation'

export default PageAnimation
